module.exports = __webpack_public_path__ + "static/media/4_Caricatura-min.7a4bbccb.jpg";